export default "__VITE_ASSET__BOkdFL6F__"